/* eslint-disable @typescript-eslint/no-explicit-any */
import {
	Avatar,
	Box,
	Chip,
	ClickAwayListener,
	Divider,
	Grid,
	List,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Paper,
	Popper,
	Stack,
	Typography,
} from '@mui/material';
// material-ui
import { useTheme } from '@mui/material/styles';
// assets
import { IconLogout, IconSettings, IconUser } from '@tabler/icons';
// project imports
import MainCard from 'components/cards/MainCard';
import Transitions from 'components/extended/Transitions';
import {
	logout,
	Selectors as AuthModuleSelectors,
} from 'modules/Authentication/store/slice';
import { useEffect, useRef, useState } from 'react';
// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// ==============================|| PROFILE MENU ||============================== //

const ProfileSection = () => {
	const theme: any = useTheme();
	const customization = useSelector((state: any) => state.customization);

	const navigate = useNavigate();

	const adminUserData = useSelector(AuthModuleSelectors.adminUserData);

	const dispatch = useDispatch();

	// const [sdm, setSdm] = useState(true);
	// const [value, setValue] = useState('');
	// const [notification, setNotification] = useState(false);
	const [selectedIndex, setSelectedIndex] = useState(-1);
	const [open, setOpen] = useState(false);
	/**
	 * anchorRef is used on different componets and specifying one type leads to other components throwing an error
	 * */
	const anchorRef: any = useRef(null);
	const handleLogout = async () => {
		dispatch(logout({}));
		navigate('/');
	};

	const handleClose = (event: any) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}
		setOpen(false);
	};

	const handleListItemClick = (event: any, index: any, route = '') => {
		setSelectedIndex(index);
		handleClose(event);

		if (route && route !== '') {
			navigate(route);
		}
	};
	const handleToggle = () => {
		setOpen(prevOpen => !prevOpen);
	};

	const prevOpen = useRef(open);
	useEffect(() => {
		if (prevOpen.current === true && open === false) {
			anchorRef.current.focus();
		}

		prevOpen.current = open;
	}, [open]);

	return (
		<>
			<Chip
				sx={{
					height: '48px',
					alignItems: 'center',
					borderRadius: '27px',
					transition: 'all .2s ease-in-out',
					borderColor: theme.palette.primary.light,
					backgroundColor: theme.palette.primary.light,
					'&[aria-controls="menu-list-grow"], &:hover': {
						borderColor: theme.palette.primary.main,
						background: `${theme.palette.primary.main}!important`,
						color: theme.palette.primary.light,
						'& svg': {
							stroke: theme.palette.primary.light,
						},
					},
					'& .MuiChip-label': {
						lineHeight: 0,
					},
				}}
				icon={
					<Avatar>
						{adminUserData.fullName[0].toUpperCase()}
						{adminUserData.fullName[1]?.toLowerCase()}
					</Avatar>
				}
				label={
					<IconSettings
						stroke={1.5}
						size='1.5rem'
						color={theme.palette.primary.main}
					/>
				}
				variant='outlined'
				ref={anchorRef}
				aria-controls={open ? 'menu-list-grow' : undefined}
				aria-haspopup='true'
				onClick={handleToggle}
				color='primary'
			/>
			<Popper
				placement='bottom-end'
				open={open}
				anchorEl={anchorRef.current}
				role={undefined}
				transition
				disablePortal
				popperOptions={{
					modifiers: [
						{
							name: 'offset',
							options: {
								offset: [0, 14],
							},
						},
					],
				}}
			>
				{({ TransitionProps }) => (
					<Transitions in={open} {...TransitionProps}>
						<Paper>
							<ClickAwayListener onClickAway={handleClose}>
								<MainCard
									border={false}
									elevation={16}
									content={false}
									boxShadow
									shadow={theme.shadows[16]}
								>
									<Box sx={{ p: 2 }}>
										<Stack>
											<Stack direction='row' spacing={0.5} alignItems='center'>
												<Typography variant='h4'>Welcome!</Typography>
												<br />
												<Typography
													component='span'
													variant='h4'
													sx={{ fontWeight: 400 }}
												>
													{adminUserData.fullName}
												</Typography>
											</Stack>
											<Typography variant='subtitle2'>
												{adminUserData.email}
											</Typography>
										</Stack>
									</Box>
									<PerfectScrollbar
										style={{
											height: '100%',
											maxHeight: 'calc(100vh - 250px)',
											overflowX: 'hidden',
										}}
									>
										<Box sx={{ p: 2 }}>
											<Divider />
											<List
												component='nav'
												sx={{
													width: '100%',
													maxWidth: 350,
													minWidth: 300,
													backgroundColor: theme.palette.background.paper,
													borderRadius: '10px',
													[theme.breakpoints.down('md')]: {
														minWidth: '100%',
													},
													'& .MuiListItemButton-root': {
														mt: 0.5,
													},
												}}
											>
												<ListItemButton
													sx={{
														borderRadius: `${customization.borderRadius}px`,
													}}
													selected={selectedIndex === 0}
													onClick={event =>
														handleListItemClick(
															event,
															0,
															'/user/account-profile/profile1',
														)
													}
												>
													<ListItemIcon>
														<IconSettings stroke={1.5} size='1.3rem' />
													</ListItemIcon>
													<ListItemText
														primary={
															<Typography variant='body2'>
																Account Settings
															</Typography>
														}
													/>
												</ListItemButton>
												<ListItemButton
													sx={{
														borderRadius: `${customization.borderRadius}px`,
													}}
													selected={selectedIndex === 1}
													onClick={event =>
														handleListItemClick(
															event,
															1,
															'/user/social-profile/posts',
														)
													}
												>
													<ListItemIcon>
														<IconUser stroke={1.5} size='1.3rem' />
													</ListItemIcon>
													<ListItemText
														primary={
															<Grid
																container
																spacing={1}
																justifyContent='space-between'
															>
																<Grid item>
																	<Typography variant='body2'>
																		Social Profile
																	</Typography>
																</Grid>
																<Grid item>
																	<Chip
																		label='02'
																		size='small'
																		sx={{
																			bgcolor: theme.palette.warning.dark,
																			color: theme.palette.background.default,
																		}}
																	/>
																</Grid>
															</Grid>
														}
													/>
												</ListItemButton>
												<ListItemButton
													sx={{
														borderRadius: `${customization.borderRadius}px`,
													}}
													selected={selectedIndex === 4}
													onClick={handleLogout}
												>
													<ListItemIcon>
														<IconLogout stroke={1.5} size='1.3rem' />
													</ListItemIcon>
													<ListItemText
														primary={
															<Typography variant='body2'>Logout</Typography>
														}
													/>
												</ListItemButton>
											</List>
										</Box>
									</PerfectScrollbar>
								</MainCard>
							</ClickAwayListener>
						</Paper>
					</Transitions>
				)}
			</Popper>
		</>
	);
};

export default ProfileSection;
